import { handleBack, handleNext, handleSubmit } from '../../components/ProgressiveFormStepper/utils';
import { getSectionIndex, getToday, getUsefulVars } from '../../handlers/helpers';
import { runAxios } from '../../handlers/axios';
import { onLink, onSubmit, save, unloadCallback } from '../../handlers';
import axios from 'axios';
import { updateSectionData } from '../../handlers/utils';

export class InterviewUtils {
  constructor(props) {
    this.props = props;
    this.stateProps = props.stateProps;
    this.formikProps = props.formikProps;
    this.resumeIndex = this.stateProps.sectionData.resumeIndex;
    this.resume = this.stateProps.dataToSave.saved.resumes[this.resumeIndex];
    this.sectionName = this.stateProps.sectionData.sectionName;
    this.navSections = this.props.navSections;

    this.sectionTitle = this.navSections[this.sectionName].label;
    this.sectionIndex = getSectionIndex(this.resume, this.sectionName);
    this.interviewImage2 = this.stateProps.domain + '/app/images/interview_results1.png';
    this.interview = this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName];
    this.qid = '';

    switch (this.sectionName) {
      case 'interview-sparl':
        this.qid = 'INT7';
        break;
      case 'interview-you':
        this.qid = 'IY2';
        break;
      case 'interview-questions':
        this.qid = 'IQ2';
        break;
      case 'new-aptitude':
        this.qid = 'aptitude_results';
        break;
      case 'grow-goals':
        this.qid = 'G3';
        break;
    }
    this.results = {};
    this.setResults();
  }

  get_title_and_subTitle() {
    const questionParts = this.navSections[this.sectionName]['question_parts'];
    const questions = this.navSections[this.sectionName]['questions'];
    for(const part of questionParts) {
      if(part.qid === this.qid) {
        return {
          'title':part['question'],
          'subTitle': part['instructions']
        };
      }
    }
    for(const question of questions) {
      if(question.qid === this.qid) {
        return {
          'title':question['question'],
          'subTitle': question['instructions']
        };
      }
    }
    return {
      'title':'title',
      'subTitle': 'subtitle',
    };
  }

  handleInterviewBack(groupedQuestions, step) {
    const questionTitle = groupedQuestions[step-1].question === undefined ? 'Interview Coach' : groupedQuestions[step-1].question;
    this.props.stateProps.setInterviewTitle(questionTitle);
    handleBack(this.props, groupedQuestions, step);
  }
  handleInterviewNext(groupedQuestions, step, secOrIndIndex) {
    const questionTitle = groupedQuestions[step+1].question;
    this.props.stateProps.setInterviewTitle(questionTitle);

    handleNext(this.props, groupedQuestions, step, secOrIndIndex);
  }

  editResults() {
    if (window.confirm('Are you sure you want to delete your existing results?')) {
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0][this.qid] = '';
      onSubmit(this.formikProps, this.stateProps, this.sectionName);
      onLink(false, this.formikProps, this.stateProps, this.sectionName, 0);
    }
  }
  exitToMenu = (props) => {
    handleSubmit(props, 'interview', 'section');
  };
  download = async (iu) => {
    const interviewResults = iu.results;
    const uv = getUsefulVars(iu.props);
    uv.stateProps.setSpinnerMessage('Message: Remember, confidence wins offers. (and occasionally free office snacks)');
    uv.stateProps.setSpinnerImage('downloadInterview.gif');
    uv.stateProps.onSpinnerOpen();
    window.removeEventListener('beforeunload', unloadCallback);
    onSubmit(uv.formikProps, uv.stateProps);
    const url = uv.stateProps.domain + '/wp-json/rsworks/v1/downloadInterviewResults';
    const firstName = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['contact'][0]['first'];
    const lastName = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['contact'][0]['last'];
    const request = {
      interviewType: this.sectionName,
      interview: interviewResults.interview,
      questions: interviewResults.questions,
      first_name:firstName,
      last_name: lastName,
      date: getToday(),
    };
    const result = await axios.post(url, request);

    let link = document.createElement('a');
    link.href = result.data;
    link.download = 'file.pdf';
    link.dispatchEvent(new MouseEvent('click'));
    window.addEventListener('beforeunload', unloadCallback);
    uv.stateProps.setMessageModal(true);
    updateSectionData({
      modalMessage: 'You\'ve downloaded your results! Check your download bar in your browser or downloads folder to view them.',
      fileUrl: result.data,
    }, uv.stateProps);
    uv.stateProps.setSpinnerImage('preview.gif');
    uv.stateProps.setSpinnerMessage('Wishing you an inbox full of amazing job offers!');
    uv.stateProps.onSpinnerClose();

    uv.stateProps.onOpen();
  }
  getInterviewCallback(result, args) {
    const props = args.props;
    const questions = result.data.questions;
    let qCounter = 0;
    for (const question of questions) {
      props.survey.section['interview-sparl'].questions[qCounter].question = question;
      qCounter++;
    }
    this.resetSpinner();
  }
  handleInterviewResultsCallback = (result, args)=> {
    /*
    args.interviewResults['INT7'] = result.data.interview;
    args.interviewResults['INT8'] = result.data.questions;
    */
    this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['INT7'] = result.data.interview;
    this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['INT8'] = result.data.questions;
    save(this.stateProps, this.resumeIndex);
    this.resetSpinner();
    handleNext(this.props, args.groupedQuestions, args.step, args.secOrIndIndex);
  }
  handleGrowResultsCallback = (result, args) => {
    args.interviewResults['G3'] = result.data.interview;
    const section = this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName];
    if(section === undefined) {
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName] = [];
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0] = {};
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['G1'] = '';
    }
    this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['G3'] = result.data.interview;
    this.resetSpinner();
    save(this.stateProps, this.resumeIndex);
    handleNext(this.props, args.groupedQuestions, args.step, args.secOrIndIndex);
  }
  handleInterviewYouResultsCallback = (result, args) => {
    args.interviewResults['IY2'] = result.data.interview;
    const section = this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName];
    if(section === undefined) {
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName] = [];
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0] = {};
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['IY1'] = '';
    }
    this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['IY2'] = result.data.interview;
    this.resetSpinner();
    save(this.stateProps, this.resumeIndex);
    handleNext(this.props, args.groupedQuestions, args.step, args.secOrIndIndex);
  }

  handleInterviewQuestionsResultsCallback = (result, args) => {
    args.interviewResults['IQ2'] = result.data.interview;
    const section = this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName];
    if(section === undefined) {
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName] = [];
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0] = {};
      this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['IQ1'] = '';
    }
    this.stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['IQ2'] = result.data.interview;
    this.resetSpinner();
    save(this.stateProps, this.resumeIndex);
    handleNext(this.props, args.groupedQuestions, args.step, args.secOrIndIndex);
  }

  getInterview() {
    const url = this.stateProps.domain + '/wp-json/rsworks/v1/get_interview_questions';
    const request = {};
    const args = {
      props: this.props,
    };
    this.setSpinner('Generating Interview Questions.\nStand By!', 'bullets.gif');
    runAxios(url, request, this.getInterviewCallback, args);
  }
  handleInterviewResults(groupedQuestions, step, secOrIndIndex) {
    const jobSeekerData = this.formikProps.values.jobSeekerData;
    const questions = [];
    for (const gQuestion of groupedQuestions) {
      if (gQuestion.qid.includes('IQ')) {
        questions.push(gQuestion.question);
      }
    }

    const responses = [];
    responses.push(jobSeekerData[0]['IQ1']);
    responses.push(jobSeekerData[0]['IQ2']);
    responses.push(jobSeekerData[0]['IQ3']);
    responses.push(jobSeekerData[0]['IQ4']);
    responses.push(jobSeekerData[0]['IQ5']);
    responses.push(jobSeekerData[0]['IQ6']);
    const targetrole = this.resume.job_title;

    const url = this.stateProps.domain + '/wp-json/rsworks/v1/get_interview_results';
    const request = {
      targetrole: targetrole,
      questions: questions,
      responses: responses,
    };
    const args = {
      props: this.props,
      groupedQuestions: groupedQuestions,
      step: step,
      secOrIndIndex: secOrIndIndex,
      interviewResults: jobSeekerData[0]
    };
    this.setSpinner('Remember, confidence wins offers.\n(and occasionally free office snacks)', 'interview_coach.gif');
    runAxios(url, request, this.handleInterviewResultsCallback, args);
  }
  handleGrowResults(groupedQuestions, step, secOrIndIndex) {
    const jobSeekerData = this.formikProps.values.jobSeekerData;
    const goals = jobSeekerData[0]['G2'];
    const targetrole = this.resume.job_title;

    const url = this.stateProps.domain + '/wp-json/rsworks/v1/get_grow_results';
    const request = {
      targetrole: targetrole,
      goals: goals,
    };
    const args = {
      props: this.props,
      groupedQuestions: groupedQuestions,
      step: step,
      secOrIndIndex: secOrIndIndex,
      interviewResults: jobSeekerData[0]
    };
    this.setSpinner('Remember, confidence wins offers.\n(and occasionally free office snacks)', 'interview_coach.gif');
    runAxios(url, request, this.handleGrowResultsCallback, args);
  }
  handleInterviewYouResults(groupedQuestions, step, secOrIndIndex) {
    const jobSeekerData = this.formikProps.values.jobSeekerData;
    const aboutYou = jobSeekerData[0]['IY1'];
    const targetrole = this.resume.job_title;

    const url = this.stateProps.domain + '/wp-json/rsworks/v1/get_interview_you_results';
    const request = {
      targetrole: targetrole,
      aboutYou: aboutYou,
    };
    const args = {
      props: this.props,
      groupedQuestions: groupedQuestions,
      step: step,
      secOrIndIndex: secOrIndIndex,
      interviewResults: jobSeekerData[0]
    };
    this.setSpinner('Remember, confidence wins offers.\n(and occasionally free office snacks)', 'interview_coach.gif');
    runAxios(url, request, this.handleInterviewYouResultsCallback, args);
  }


  handleInterviewQuestionsResults(groupedQuestions, step, secOrIndIndex) {
    const jobSeekerData = this.formikProps.values.jobSeekerData;
    const questionsForThem = jobSeekerData[0]['IQ1'];
    const targetrole = this.resume.job_title;

    const url = this.stateProps.domain + '/wp-json/rsworks/v1/get_interview_questions_results';
    const request = {
      targetrole: targetrole,
      questionsForThem: questionsForThem,
    };
    const args = {
      props: this.props,
      groupedQuestions: groupedQuestions,
      step: step,
      secOrIndIndex: secOrIndIndex,
      interviewResults: jobSeekerData[0]
    };
  this.setSpinner('Remember, confidence wins offers.\n(and occasionally free office snacks)', 'interview_coach.gif');

    runAxios(url, request, this.handleInterviewQuestionsResultsCallback, args);
  }

  setResults() {
    switch (this.sectionName) {
      case 'interview-sparl':
        this.results.interview = this.interview?.[0]?.['INT7'] || null;
        this.results.questions = this.interview?.[0]?.['INT8'] || null;
        break;
      case 'interview-you':
        this.results.interview = this.interview?.[0]?.['IY2'] || null;
        this.results.questions = null;
        break;
      case 'interview-questions':
        this.results.interview = this.interview?.[0]?.['IQ2'] || null;
        this.results.questions = null;
        break;
      case 'new-aptitude':
        this.results.interview = this.interview?.[0]?.['aptitude_results'] || null;
        this.results.questions = null;
        break;
      case 'grow-goals':
        this.results.interview = this.interview?.[0]?.['G3'] || null;
        this.results.questions = null;
        break;
      default:
        this.results.interview = null;
    }
  }

  setSpinner (message,image) {
    this.stateProps.setSpinnerMessage(message);
    this.stateProps.setSpinnerImage(image);
    this.stateProps.onSpinnerOpen();
  }
  resetSpinner() {
    this.stateProps.setSpinnerImage('default.gif');
    this.stateProps.setSpinnerMessage('');
    this.stateProps.onSpinnerClose();
  }
}